import React from 'react';

const LeadReport = () => {
  return <div>LeadReport</div>;
};

export default LeadReport;
